var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showMainList,
            expression: "showMainList"
          }
        ],
        staticClass: "main-content"
      },
      [
        _c(
          "search-item",
          {
            attrs: {
              "config-module": "410015205",
              reset: true,
              "custom-sim-query-placeholder": _vm.$t(
                "Message.QuickSearchBusinessNo"
              ),
              no: "1"
            },
            on: {
              "click-more": function(value) {
                return (_vm.isAdvancedQuery = value)
              },
              simSearchItemCallBack: _vm.toSimpleQuery,
              advSearchItemCallBack: _vm.toAdvancedQuery,
              advSearchItemResetCallBack: _vm.toAdvancedQuery
            }
          },
          [
            _c(
              "div",
              { attrs: { slot: "operations" }, slot: "operations" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", no: "2" },
                    on: {
                      click: function($event) {
                        return _vm.confirmHandler()
                      }
                    }
                  },
                  [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_ConfirmR")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", no: "3" },
                    on: {
                      click: function($event) {
                        return _vm.rejectHandler()
                      }
                    }
                  },
                  [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_Refuse")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "410015205",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: _vm.onGridReady
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.rowData,
                    expression: "rowData"
                  }
                ],
                class: "fixedBottom",
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "flex-wrap": "wrap"
                }
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.selectedDataList.length > 0,
                        expression: "selectedDataList.length > 0"
                      }
                    ]
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          this.$t("CargoMsg.Cargo_Choose") +
                            _vm.selectedDataList.length +
                            ":"
                        ) +
                        " "
                    )
                  ]
                ),
                _vm.reCalc
                  ? _c("charge-currency-total-group", {
                      key: 1,
                      attrs: {
                        type: "revenue",
                        "amount-to-currency": _vm.localCurrency,
                        "currency-field": "billingCurrency",
                        "data-field": "clearAmountString",
                        "data-provider":
                          _vm.selectedDataList.length > 0
                            ? _vm.selectedDataList
                            : _vm.rowData,
                        "ar-field": "ar"
                      }
                    })
                  : _vm._e(),
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(this.$t("CargoMsg.Cargo_TotalWriteOffAmount")) +
                      " "
                  )
                ])
              ],
              1
            ),
            _c("cargo-pagination", {
              attrs: {
                "config-module": "410015205",
                total: _vm.filter.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize,
                "page-sizes": [10, 20, 30, 50, 100, 200, 500]
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.toQuery
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }